import React from 'react';
import { Flex, Loader } from '@grubhubprod/gh-cookbook-react/dist';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';

export function BalanceInvoicesSectionLoading(): JSX.Element {
  return (
    <PageSection dataTestId="balance-invoices-section">
      <Flex alignItems="center" justifyContent="center" minHeight="140px">
        <Loader size="md" />
      </Flex>
    </PageSection>
  );
}
